import { IFarm } from "../types/IFarm";

const REFACTION_2025_ALLOWED_REGISTRATION_NUMBERS = new Set<string>([
  "804681009671",
]);

export function canAccessRefaction2025(farm: IFarm | null): boolean {
  const reg = farm?.registrationNumber?.trim();
  if (!reg) return false;
  return REFACTION_2025_ALLOWED_REGISTRATION_NUMBERS.has(reg);
}
